var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"table-list-empty",attrs:{"slot":"empty"},slot:"empty"},[_c('img',{attrs:{"src":require("@/assets/img/table_empty.png"),"alt":"","width":"160","height":"160"}}),_c('p',{staticClass:"empty-text"},[_vm._v(_vm._s(_vm.$t("base.no-data")))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }